import { ConsentManagementSlug } from "@/consent-management/consentManagement";
import { SaaSDestination } from "@/destinations/destinations";
import {
  DestinationValidationResult,
  DestinationValidity,
  getDestinationValidity,
} from "@/destinations/validation";
import { CurrentProject } from "@/hooks/use-project";
import { AccountMetadata } from "@/reducers/environments";
import {
  LoadedConsentManagementInfo,
  LoadedDestinationInfo,
} from "@/types/global";

const BLOCKING_VALIDITIES = new Set([
  DestinationValidity.totallyInvalid,
  DestinationValidity.totallyInvalidClientModeWhenHIPAA,
  DestinationValidity.totallyInvalidMissingAllowlistWhenHIPAA,
  DestinationValidity.totallyInvalidTermsOfServiceTestFailed,
  DestinationValidity.totallyInvalidAudienceConnectionTestFailed,
]);

/**
 * A disabled destination always resolves to `totallyInvalidDisabled`, which
 * hides the problems turning it on would run into. Validate it as if it were
 * already on.
 */
export function getValidityIfTurnedOn({
  accountMetadata,
  project,
  configuredDestination,
  destination,
  consentConfigs,
}: {
  accountMetadata: AccountMetadata;
  project: CurrentProject;
  configuredDestination: LoadedDestinationInfo;
  destination: SaaSDestination;
  consentConfigs?: Record<ConsentManagementSlug, LoadedConsentManagementInfo>;
}): DestinationValidationResult {
  return getDestinationValidity(
    accountMetadata,
    project,
    { ...configuredDestination, enabled: true },
    destination,
    consentConfigs,
  );
}

export function blocksTurnOn(validity: DestinationValidationResult): boolean {
  return BLOCKING_VALIDITIES.has(validity.validity);
}
